import posthog from 'posthog-js';

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

if (
  typeof window !== 'undefined' &&
  token &&
  !token.startsWith('__NEXT_RUNTIME') &&
  !window.location.hostname.includes('localhost') &&
  !window.location.hostname.includes('127.0.0.1')
) {
  posthog.init(token, {
    // First-party reverse proxy (see next.config.ts rewrites); ui_host links
    // back to the PostHog app. Session replay is enabled in project settings.
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    cross_subdomain_cookie: false,
    loaded: (ph) => {
      // Identify the logged-in user. Most sso pages are pre-auth (login/register/
      // reset) and whoami returns 401, so identify() simply no-ops there.
      fetch('/api/auth/whoami', { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          const user = data?.user;
          if (!user?.id) return;
          ph.identify(user.id, {
            email: user.email,
            name: user.user_metadata?.display_name || user.email,
          });
        })
        .catch(() => {
          // Network/auth hiccup — continue unattributed rather than throw.
        });
    },
  });
}
